export default class StrateActionsComponent {
    constructor() {
        if ($('.strate--actions').length > 0) {
            StrateActionsComponent.onDesktop()

            // If we're on a mobile device, start checking for page resizing
            if (window.matchMedia('(max-width: 1000px)').matches) {
                window.addEventListener('resize', StrateActionsComponent.onDesktop)
            }
        }
    }

    static onDesktop() {
        if (window.matchMedia('(min-width: 1000px)').matches) {
            window.removeEventListener('resize', StrateActionsComponent.onDesktop)

            $("[data-trigger='picto-bg']").on('mouseenter', function () {
                const imageUrl = $(this).data('image-url')
                const imageSlug = $(this).data('image-slug')

                if (imageUrl.length) {
                    $("[data-element='picto-bg'] img").removeClass('new')

                    $("[data-element='picto-bg']").prepend(
                        `<img src=${imageUrl} alt=${imageSlug} class='new'>`,
                    )

                    $("[data-element='picto-bg'] img").bind('load', () => {
                        $("[data-element='picto-bg'] img:not(.new)").fadeOut(200)

                        setTimeout(() => {
                            $("[data-element='picto-bg'] img:not(.new)").remove()
                        }, 200)
                    })
                }
            })
        }
    }
}
